import {CompilationTargetId} from "../types/CompilationTargetId";
import {compilationTargets} from "./compilationTargets";

export function isTargetIdCompatible(
  requestedTargetId: CompilationTargetId,
  foundTargetId: CompilationTargetId
): boolean {
  return requestedTargetId === foundTargetId ||
    compilationTargets[requestedTargetId].fallbacks.includes(foundTargetId);
}
